import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { CourseCardComponent } from 'src/app/components/cards/course-card/course-card.component';
import { LocalstorageService } from 'src/app/services/localstorage.service';

@Component({
  selector: 'app-courses',
  standalone: true,
  imports: [CommonModule,
    CourseCardComponent,
    RouterOutlet],
  templateUrl: './courses.component.html',
  styleUrls: ['./courses.component.scss']
})
export class CoursesComponent {
  option: string = 'Todos los cursos';
  infoUser: any;

  constructor(private localStorage: LocalstorageService) { }

  ngOnInit(){
    if(this.localStorage.getItem('profile_current_user')){
      this.infoUser = this.localStorage.getCurrentUserProfileAsJson();
    }
  }



}
